import React from 'react';

import { Body } from 'js/design_system/Body';

const TESTIMONIALS: ReadonlyArray<string> = [
  "'Saved me hours of literature search' — Researcher, MIT",
  "'Found the exact citation in two clicks' — PhD candidate, Stanford",
  "'Faster than chasing PDFs across publisher sites' — Postdoc, Cambridge",
  "'My go-to for grant lit reviews' — Researcher, ETH Zürich",
  "'Beats institutional access for breadth' — Faculty, UCL",
];

/**
 * Single-line testimonial rendered below the CTA when V18
 * (`trust_signal_v18`) is active. Tests whether modal-level trust
 * signaling lifts CTR (T14 falsification — T14's bet is that the modal
 * pitches and /checkout owns trust).
 *
 * Pick is deterministic by `userId` so a returning user sees the same
 * testimonial each time. Falls back to the first testimonial when
 * `userId` is unavailable.
 */
export function TrustSignalLine({
  userId,
}: {
  userId: string | number | null | undefined;
}) {
  const idx =
    userId == null
      ? 0
      : String(userId)
          .split('')
          .reduce((acc, ch) => acc + ch.charCodeAt(0), 0) % TESTIMONIALS.length;
  return (
    <Body
      size="xs"
      style={{ color: 'var(--color-text-subtle)', textAlign: 'center' }}
    >
      {TESTIMONIALS[idx]}
    </Body>
  );
}
